import hasDiagramError from "./hasDiagramError";

const transientDiagramValidationSummaries = new Set([
    'Attribute no longer available. Please select another.',
    'No privacy configurations set. Please configure data privacy.',
    'Privacy configuration incomplete. Please complete it.',
]);

function checkDiagramError(file) {
    const hasError = hasDiagramError(file?.diagram?.nodes);
    const cleanSubjectSchemaError = (file?.validation || []).filter((validation) => {
        if (validation?.code === 'SUBJECT_SCHEMA_FETCH_FAILED') {
            return false;
        }

        const summary = String(validation?.summary || '').trim();
        if (transientDiagramValidationSummaries.has(summary)) {
            return false;
        }

        return true;
    });
    if (hasError) {
        const findValidationErrors = cleanSubjectSchemaError.find(v => v.code === 'DIAGRAM_ERROR');
        if (findValidationErrors) {
            return {
                ...file,
                validation: [...cleanSubjectSchemaError]
            }
        } else {
            return {
                ...file,
                validation: [...cleanSubjectSchemaError, {
                    code: 'DIAGRAM_ERROR',
                    summary: 'Errors in diagram. Please review and fix them.',
                    detail: [],
                    isNewIssue: true
                }]
            }
        }
    } else {
        const newValidation = cleanSubjectSchemaError.filter(v => v.code !== 'DIAGRAM_ERROR');
        return {
            ...file,
            validation: newValidation
        }
    }
}

export default checkDiagramError